<section class="separator-demo">
  <header class="separator-demo__controls">
    <h3>Separator mode</h3>
    <div class="separator-demo__options">
      <label *ngFor="let option of separatorOptions">
        <input
          type="radio"
          name="separatorMode"
          [value]="option.id"
          [checked]="isSelected(option.id)"
          (change)="onModeChange(option.id)"
        />
        <span class="separator-demo__label">
          <strong>{{ option.label }}</strong>
          <small>{{ option.description }}</small>
        </span>
      </label>
    </div>
  </header>

  <ui-panel-header
    [panelHeaderTitle]="panelTitle"
    [metadataItems]="metadataItems"
    [leftInputs]="leftInputs"
    [additionalActions]="additionalActions"
    [legendItems]="legendItems"
    [verticalSeparators]="separatorSetting()"
  >
    <p>
      Toggle the radio buttons above to see separators appear before the selected sections.
      No other part of the header configuration changes.
    </p>
  </ui-panel-header>
</section>
